const initVideoSlider = () => {
    const swiperContainer = document.querySelector('.customVideoSwiper');
    if (!swiperContainer) return;

    const swiper = new Swiper('.customVideoSwiper', {
        slidesPerView: 1.4,
        spaceBetween: 15,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            750: { slidesPerView: 3.2, spaceBetween: 20 },
            1200: { slidesPerView: 3.5, spaceBetween: 25 }
        }
    });

    const videoCards = document.querySelectorAll('.video-card');
    videoCards.forEach(card => {
        const video = card.querySelector('.slider-video');
        const btn = card.querySelector('.play-pause-btn');
        if(!video || !btn) return;

        // Click handler for the button/video
        card.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                // Hide button when playing
                btn.style.opacity = '0';
                btn.querySelector('.play-icon').style.display = 'none';
                btn.querySelector('.pause-icon').style.display = 'block';
            } else {
                video.pause();
                // Show button when paused
                btn.style.opacity = '1';
                btn.querySelector('.play-icon').style.display = 'block';
                btn.querySelector('.pause-icon').style.display = 'none';
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', initVideoSlider);
document.addEventListener('shopify:section:load', initVideoSlider);